import { useQuery } from '@tanstack/react-query';
import { getRequestTracking } from '../../../api/cmail.api';

export const useRequestTracking = (msgId: string, enabled = true) => {
  return useQuery({
    queryKey: ['request-tracking', { msgId }],
    queryFn: async () => {
      const response = await getRequestTracking(msgId);

      // The API returns the tracking data directly
      return response;
    },
    enabled: enabled && Boolean(msgId),
    staleTime: 30000, // Consider data stale after 30 seconds
    retry: false, // Don't retry on failure to avoid multiple failed requests
  });
};
